"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./BlockListItems.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _BoundedCard = _interopRequireDefault(require("../BoundedCard/BoundedCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Images Sizes here are the same when used in Carousel to preserve the 3:2 image ratio
const imageSizes = {
  desktop: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  tablet: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  mobile: {
    width: 525,
    height: 350,
    ratio: {
      width: 3,
      height: 2
    }
  }
};

// Double resolution for centeredImageSizes used in Bounded Cards
const centeredImageSizes = {
  desktop: {
    width: 543,
    height: 362,
    ratio: {
      width: 3,
      height: 2
    }
  },
  tablet: {
    width: 543,
    height: 362,
    ratio: {
      width: 3,
      height: 2
    }
  },
  mobile: {
    width: 720,
    height: 480,
    ratio: {
      width: 3,
      height: 2
    }
  }
};
const BoundedCards = _ref => {
  let {
    content,
    VideoComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  } = _ref;
  const GatsbyImage = content?.GatsbyImage;
  const nestedInTab = content?.tab;
  const centered = content?.centered;
  const {
    backgroundColor
  } = content?.theme || {};
  const renderBoundedCards = () => {
    if (content.cards && content.cards.length) {
      return content.cards.map((card, index) => {
        const cardContent = {
          locale: card?.locale,
          eyebrow: card?.eyebrow,
          header: card?.header,
          image: card?.image,
          imageSizes: centered ? centeredImageSizes : imageSizes,
          displayButton: content?.displayButton,
          cardLink: card?.cardLink,
          bgColor: !card?.image ? "grey" : "",
          text: card?.text,
          GatsbyImage: GatsbyImage,
          Link: content?.Link,
          cardAlignment: content?.cardAlignment,
          buttonSecondary: content?.buttonSecondary
        };
        if (cardContent?.cardLink) {
          cardContent.cardLink.external = (0, _checkForExternalLink.default)(cardContent?.cardLink?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_BoundedCard.default, {
          key: index,
          VideoComponent: VideoComponent ? VideoComponent : null,
          content: cardContent,
          contentfulId: card?.contentfulId ? card?.contentfulId : null
        });
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-bounded-cards ter-bounded-cards--${content?.cards?.length}-cards`,
    style: {
      background: nestedInTab ? "#fff" : backgroundColor
    }
  }, renderBoundedCards());
};
var _default = BoundedCards;
exports.default = _default;